
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"#FFF","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M10.533 20.694a10.165 10.165 0 1110.161-10.16c-.008 5.608-4.552 10.152-10.16 10.16zm0-18.852a8.691 8.691 0 108.688 8.691 8.698 8.698 0 00-8.688-8.69z"}}),_c('circle',{attrs:{"cx":"10.533","cy":"7.07","r":"1.179"}}),_c('path',{attrs:{"d":"M9.616 9.155h1.813v6.016H9.616z"}})])])
      }
    
      }
    